import React from 'react';
import { Link } from 'react-router-dom';
import RouteEndPoints from '../../../utilities/RouteEndPoints';
import ProgressBar from '../../UI/ProgressBar/ProgressBar';

import classes from './ModuleReportCard.module.css';

const ModuleReportCard = (props) => {

    return (
        <div className={[classes.ModuleReportCard, props.forPerformanceTab ? classes.HorizontalFlex : ''].join(' ')}>
            {props.forPerformanceTab === true ? null : <h3>Module Report</h3>}
            <div className={classes.ProgressCard}>
                <p className={classes.ProgressStat}>{props.classGrades}<span>%</span></p>
                <p className={classes.ProgressText}>Class Grade</p>
                <div className={classes.ProgressBarDiv}>
                    <ProgressBar
                        styleclass={props.classGrades >= 80 ? "Green"
                            : props.classGrades >= 70 ? "Yellow" : "Red"}
                        showProgressText={false} progress={props.classGrades} />
                </div>
            </div>
            {
                props.forPerformanceTab === true
                    ? <>
                        <div className={classes.ProgressCard}>
                            <p className={classes.ProgressStat}>{props.activeStudents}<span> / {props.totalStudents}</span></p>
                            <p className={classes.ProgressText}>Active Students</p>
                            <div className={classes.ProgressBarDiv}>
                                <ProgressBar styleclass={props.activeStudents >= 80 ? "Green"
                                    : props.activeStudents >= 70 ? "Yellow" : "Red"}
                                    showProgressText={false} progress={props.activeStudents} />
                            </div>
                        </div>
                        <div className={classes.ProgressCard}>
                            <p className={classes.ProgressStat}>{props.rating}</p>
                            <p className={classes.ProgressText}>Instructor Rating</p>
                            <div className={classes.ProgressBarDiv}>
                                <ProgressBar styleclass={props.rating >= 80 ? "Green"
                                    : props.rating >= 70 ? "Yellow" : "Red"}
                                    showProgressText={false} progress={props.rating} />
                            </div>
                        </div>
                    </>
                    : <>
                        <div className={classes.ProgressCard}>
                            <p className={classes.ProgressStat}>{props.rating}</p>
                            <p className={classes.ProgressText}>My Rating</p>
                            <div className={classes.ProgressBarDiv}>
                                <ProgressBar styleclass={props.rating >= 80 ? "Green"
                                    : props.rating >= 70 ? "Yellow" : "Red"}
                                    showProgressText={false} progress={props.rating} />
                            </div>
                        </div>
                        <div className={classes.ProgressCard}>
                            <p className={classes.ProgressStat}>{props.activeStudents}<span> / {props.totalStudents}</span></p>
                            <p className={classes.ProgressText}>Active Students</p>
                            <div className={classes.ProgressBarDiv}>
                                <ProgressBar styleclass={props.activeStudents >= 80 ? "Green"
                                    : props.activeStudents >= 70 ? "Yellow" : "Red"}
                                    showProgressText={false} progress={props.activeStudents} />
                            </div>
                        </div>
                    </>
            }
            {
                props.forPerformanceTab === true
                    ? null
                    : <Link className={classes.ProgressTextLink} to={RouteEndPoints.REPORTS_PAGE + '/overall-report'} >
                        VIEW DETAILED REPORT</Link>
            }
        </div>
    );
}

export default ModuleReportCard;